import { CustomerDetails } from '../entities/requisition-model';
import { BasePluginData } from './base-plugin-data';

export class RequisitionData extends BasePluginData {
  override get pluginStepName(): string { return 'RequisitionData'; }

  /**
     * Document identifier.
     * @type(GUid)
     * @default ""
     * @example "6811d1a920529ad393ec323e"
    */
  docId: string = '';

  /**
   * Document number for maintaing requisition no. will be auto created via some logic
   * @type(string)
   * @default ""
   * @example "Req/2025-05-19/1"
   * */
  docNo: string = '';

  /**
   * Date of the document.
   * @type(datetime)
   * @default ""
   * @example 2025-05-01
   *  */
  docDate: Date = new Date(); /**
     * Customer related details.
     * @type (CustomerDetails)
     *
     * */
  customerDetails: CustomerDetails = new CustomerDetails();
  /** Current status of the request. */
  status: string = '';

  enquiryId: string = '';

  requisitionType: string = '';

  paymentTerms: string='';
}
